import { useState } from 'react'
import { useQueue } from './queue'
import { QueueSheet } from './OfflineCounter'

/**
 * شريطُ الترحيل في الصندوق المتّصل — <b>يظهر حين تنتظر عمليّاتٌ أو فشلت</b> (`0052`).
 *
 * والترحيلُ نفسُه تلقائيّ؛ الشريطُ خبرٌ لا زرّ: «٣ عمليّاتٍ تُرحَّل الآن».
 */
export default function SyncBar() {
  const { pending, failed } = useQueue()
  const [open, setOpen] = useState(false)

  if (pending.length === 0 && failed.length === 0) {
    return null
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`flex w-full items-center justify-between gap-2 border-b px-3 py-2 text-sm ${
          failed.length > 0 ? 'border-danger/40 bg-danger/10' : 'border-ok/40 bg-ok/10'
        }`}
      >
        <span>
          {pending.length > 0
            ? <>يُرحَّل ما جرى دون اتّصال — <b className="tabular">{pending.length}</b> تنتظر</>
            : 'رُحّل كلُّ ما جرى دون اتّصال'}
        </span>
        {failed.length > 0 && <b className="text-danger">{failed.length} لم تُرحَّل</b>}
      </button>

      {open && <QueueSheet onClose={() => setOpen(false)} />}
    </>
  )
}
